import React from "react";
import { Modal } from "rsuite";

const CommonModal = (props) => {
  const { open, size, onClose, title, className } = props;

  return (
    <div>
      <Modal size={size || "sm"} open={open} onClose={onClose} className={className}>
        <Modal.Header className="testHeader">
          <Modal.Title className="leave_title p-3">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>{props.children}</>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CommonModal;
